import { BadgeProps } from '@doveit/bricks';
import { FeedbackStatus } from '../domain/types';

export const feedbackStatusLabels: Record<FeedbackStatus, string> = {
  [FeedbackStatus.TODO]: 'Da fare',
  [FeedbackStatus.COMPLETED]: 'Completata',
  [FeedbackStatus.TO_REVIEW]: 'Da revisionare',
  [FeedbackStatus.REVIEWED]: 'Revisionata',
  [FeedbackStatus.ARCHIVED]: 'Archiviata',
  [FeedbackStatus.KO_CANNOT_CONTACT]: 'Non risponde',
};

export const feedbackStatusColors: Record<FeedbackStatus, BadgeProps['color']> = {
  [FeedbackStatus.TODO]: 'warning',
  [FeedbackStatus.COMPLETED]: 'success',
  [FeedbackStatus.TO_REVIEW]: 'info',
  [FeedbackStatus.REVIEWED]: 'success',
  [FeedbackStatus.ARCHIVED]: 'critical',
  [FeedbackStatus.KO_CANNOT_CONTACT]: 'critical',
};
